/** 组织树 */

import GroupTree from './GroupTree.vue';

export default GroupTree;